module.exports = __webpack_public_path__ + "img/pic3.da3386b6.png";